module.exports = __webpack_public_path__ + "static/introduction-mobile-c6492a61f047501208bfe1f0f3a6c0ba.png";